import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        pdfDownloadIconFeature: {
          module: () => import('./pdf-download-icon.module').then((m) => m.PdfDownloadIconModule),
        },
      }
    }),
  ]
})
export class PdfDownloadIconFeatureModule {}
